import { useEffect, useRef, useState } from 'react';
import useVisibleSprite from './useVisibleSprite';
import '../assets/buffalo-ui/buffalo-ui.css';
import '../assets/buffalo-ui/buffalo-sleep.css';
import './BuffaloSprites.css';

// Sprite sheets are the supplied artwork, with no image rescaling or redrawing.
export function MonitorBuffalo({ live = false }) {
  const [ref, visible] = useVisibleSprite();
  const [playing, setPlaying] = useState(true);
  return <span ref={ref} role="img" aria-label="Buffy monitoring the class" className={`buffalo-monitor${playing ? ' is-playing' : ''}${visible ? '' : ' is-paused'}`}
    data-live={live} onMouseEnter={() => setPlaying(true)} onAnimationEnd={() => setPlaying(false)} />;
}

export function PeekingBuffalo() {
  const [ref, visible] = useVisibleSprite();
  return <span ref={ref} aria-hidden="true" className={`buffalo-peeker is-playing${visible ? '' : ' is-paused'}`} />;
}

export function SleepingBuffalo({ awake }) {
  const [ref, visible] = useVisibleSprite();
  const [state, setState] = useState(awake ? 'standing' : 'sleeping');
  const previousAwake = useRef(awake);
  useEffect(() => {
    if (previousAwake.current === awake) return;
    previousAwake.current = awake;
    setState(awake ? 'waking' : 'sleeping');
  }, [awake]);
  return <span ref={ref} aria-hidden="true" className={`buffalo-sleeper${visible ? '' : ' is-paused'}`} data-state={state}
    onAnimationEnd={e => { if (e.animationName === 'buffalo-wake') setState('standing'); }} />;
}
